import type { ReadOnlyExperiments } from '@wix/fe-essentials/dist/types/exports/experiments';

export const shouldDisplayHarmonyNotifications = (
  experiments: ReadOnlyExperiments,
) => {
  return experiments?.enabled('specs.dcc.displayHarmonyNotifications');
};

export const shouldDisplayAppBuilderCliTemplatesModal = (
  experiments: ReadOnlyExperiments,
) => {
  return experiments?.enabled('specs.dcc.appBuilderCLITemplates');
};
